module.exports = __webpack_public_path__ + "static/media/I_wa_ux.548e8e3c.png";